<template>
	<div>
		<div class="row">
			<div class="exchange mt-5">
				<div class="element-box">
					<h6 data-v-7e0e9be3="" class="element-header">{{ t.p2p_money_transfer.send_money_to_friend }}</h6>
					<div v-if="isLoading">
						{{ t.process_loading }}
					</div>
					<div v-if="formProcess > 0">
						<div class="alert alert-success" v-if="formProcess == 200">
							{{ t.form.success }}
						</div>
						<div class="alert alert-danger" v-if="formProcess == 403">
							{{ t.error.access_denied_content }}
						</div>
						<div class="alert alert-danger" v-if="formProcess == 404">
							{{ t.error.notfound_content_list }}
						</div>
					</div>
					<symForm :options="opt" :data="formData" v-on:sended="getForm" :form="Form" :formProcess="formProcess" v-if="Form" />
				</div>

				<div class="element-box">
					<div class="col-12 p-0">
						<div class="listy b-b" v-if="meta && !userNotFound">
							<span class="label">
								{{ t.user.username }}
							</span>
							{{ meta.username }}
						</div>

						<div v-if="userNotFound" class="alert alert-danger">
							{{ t.user.notfound.users }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

    import symForm from '@/components/form/symForm.vue'
    export default {
        name: 'transfer',
        components: { symForm },
        data () {
            return {
                isLoading: false,
                session: session,
                userLoader: true,
	            meta: null,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                Form: null,
                translationForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: [],
                userNotFound: null
            }
        },
        watch: {
            '$route.params.id' () {
                this.getForm();
            }
        },
        mounted () {
            this.getForm();

        },
        methods: {
            resetStatus () {
                this.formProcess = 0;
            },
            async fetchRegions () {

        this.$http.get(api+'api/v1/regions')
            .then(response => {

            this.regions = response.body.result.regions;
    }, response => {

        })
    },
    async updateCK () {
        //for(var instanceName in CKEDITOR.instances)
        //CKEDITOR.instances[instanceName].updateElement();
    },
    async multiSelect () {

        var e = document.getElementsByClassName("choicesx");
        for (var i = 0; i < e.length; i++){
            var name = e[i].getAttribute("name");

            var element = e[i];

            var example = new Choices(element, {
                removeItemButton: true,

            });
        }

        //CKEDITOR.replaceAll();
    },
    listenForm (){
            var th = this;
	        setTimeout(() => {
	            window.document.getElementsByName("form[to]")[0].addEventListener('change', th.changeUser);
	        }, 1000);
    },
    changeUser (t) {

        this.$http.get(api+'api/v1/user/info/'+window.document.getElementsByName("form[to]")[0].value).then(response => {

            this.meta = response.body.result;
	        this.userNotFound = null;

        }, response => {
			this.userNotFound = true;
        })
    },
    async getForm (data) {

        if(!this.isLoading) {
            this.isLoading = true;
            this.Form = null;
            this.formProcess = 0;
            if(data) {

                //this.Form = null;
                this.$http.post(api+'api/v1/send_money',
                    data )
                    .then(response => {
                this.Form = response.body.result;
                this.formProcess = 200;
                this.isLoading = false;
                this.listenForm()
                //swal('', this.t.processing.success, "success")

                setTimeout(this.resetStatus, 5000);

            }, response => {
                    this.Form = response.body.result;
                    this.formProcess = 400;
                    this.isLoading = false;

                    //swal(this.t.processing.error, this.t.processing.check, "error")
                })

            } else {
                this.$http.get(api+'api/v1/send_money').then(response => {

                this.Form = response.body.result;
                this.formData = response.body.form_data;
                this.isLoading = false;
                this.listenForm()

                }, response => {
                    this.isLoading = false;
                    this.formProcess = response.status;
                })
            }
        }
    },
    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

	.exchange {
		width: 400px;
		margin: auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/transfer/form/transfer.vue